import * as React from "react";
import {
  Box, Container, Typography,
} from "@mui/material";
import ButtonComponent from "components/Button";
import PropTypes from "prop-types";
import {
  schema,
  getButtonDataSendApproved,
  getButtonDataSendDisable,
  getButtonDataSendDelete,
  getButtonData,
  getTextfieldData
} from "./helper";
import {checkUserAllowed, getImageOrLogo, getImageOrLogoSrc, getLocalDate, openURL} from "helpers/utils";
import {H2, H4, H5} from "components/CustomTypography";
import TextFieldComponent from "components/TextField";
import {DATE_FORMAT} from "config/constants";
import ImageAlbum from "components/elements/main/ImageAlbum";
import CustomSectionCreator from "components/CustomSectionCreator";
import AdminOfferListItem from "components/elements/admin/offers/AdminOfferListItem";
import {useState} from "react";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import AdminSellerShopDetail from "components/elements/admin/shops/AdminSellerShopDetail";

const AdminOfferSettingEditor = (props) => {


  const  {
    setState, offer, updateOfferSettingClicked, updateOfferInfoClicked, cancelEdit, isLoading, userDetails, history, selectedOffer,
        onCancel, shopoffers
  } = props;

  const [shopModeState, setShopModeState] = useState("PREVIEW");

  const {
     _id, offer_id, name, description
  } = selectedOffer;

  const handleShopButtonClick = () => {
    setShopModeState("SHOP_DETAIL");
  };

  const [blur, setblur] = React.useState({
    name: false,
    description: false,
  });


  const handleTextFieldChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });
  };

  const hasError = () => {
    try {
      return !schema.validateSync(selectedOffer);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.name || blur.description );

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, selectedOffer);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

  const onFinishApproved = () => {
    updateOfferSettingClicked({
      offer_id, status: "approve",
    });
  };

  const onFinishDisable = () => {
    updateOfferSettingClicked({
      offer_id, status: "disable",
    });
  };

  const onFinishDelete = () => {
    updateOfferSettingClicked({
      offer_id, status: "delete",
    });
  };

  const onFinishUpdate = () => {
    updateOfferInfoClicked({
      offer_id, name, description,
    });
  };

  const renderOfferUpdates = () => {

    return <>
    <Box>

    {((!isLoading && !offer.is_offer_active) && (checkUserAllowed(userDetails.userlevel, "approveoffer"))) &&
    getButtonDataSendApproved(onFinishApproved).map((element) => (
        <ButtonComponent
            type={element.type}
            variant={element.variant}
            onClick={element.onClick}
            disabled={element.disabled}
            name={element.name}
            size="small"
        />
    ))
    }
    {((!isLoading && offer.is_offer_active) && (checkUserAllowed(userDetails.userlevel, "disableoffer"))) &&
    getButtonDataSendDisable(onFinishDisable).map((element) => (
        <ButtonComponent
            type={element.type}
            variant={element.variant}
            onClick={element.onClick}
            disabled={element.disabled}
            name={element.name}
            size="small"
        />
    ))
    }
  </Box>
    <Box mb={2}>
      {((!isLoading && !offer.is_offer_active) && (checkUserAllowed(userDetails.userlevel, "disableoffer"))) &&
          getButtonDataSendDelete(onFinishDelete).map((element) => (
              <ButtonComponent
                  type={element.type}
                  variant={element.variant}
                  onClick={element.onClick}
                  disabled={element.disabled}
                  name={element.name}
                  size="small"
              />
          ))
      }
    </Box>
    <Box mb={2}>
      {getTextfieldData(name, description).map((element) => (
          <Box className="textfield" m={2}>
            <TextFieldComponent
                required
                label={element.label}
                value={element.value}
                error={!!getError(element.onChangeField)}
                helperText={getError(element.onChangeField)}
                onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
            />
          </Box>
      ))}

      <Typography align="center">
        {getButtonData(onFinishUpdate, cancelEdit, hasError, isTouched).map((element) => (
            <ButtonComponent
                sx={{
                  m: 2,
                }}
                type={element.type}
                variant={element.variant}
                onClick={element.onClick}
                disabled={element.disabled}
                name={element.name}
            />
        ))}
      </Typography>
    </Box>
    </>
  }


  const renderSearchModule = () => (
      <Container>
        <Box mb={2}>
          <Box width="100%" alignItems="center">
            <H2 textAlign="left" title={offer.name} ellipsis>
              {offer.name}
            </H2>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Description:</H5>
            </Box>
            <Box width="70%">
              {offer.description}
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Valid till:</H5>
            </Box>
            <Box width="70%">
              {getLocalDate(offer.valid_date, DATE_FORMAT)}
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Offer Status:</H5>
            </Box>
            <Box width="70%">
              {offer.is_offer_active === true ? "Active" : "Inactive"}
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Offer Created:</H5>
            </Box>
            <Box width="70%">
              {getLocalDate(offer.offer_created_at, DATE_FORMAT)}
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Shop Name:</H5>
            </Box>
            <Box width="70%">
              {offer.title}
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>View Shop</H5>
            </Box>
            <Box width="70%">
              <ButtonComponent
                  type="primary"
                  variant="outlined"
                  name="View Shop"
                  size="small"
                  onClick={handleShopButtonClick}
              />
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Shop Status:</H5>
            </Box>
            <Box width="70%">
              {offer.is_shop_active === true ? "Active" : "Inactive"}
            </Box>
          </Box>
          <Box width="100%" alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Shop Created:</H5>
            </Box>
            <Box width="70%">
              {getLocalDate(offer.shop_created_at, DATE_FORMAT)}
            </Box>
          </Box>
        </Box>
        {(checkUserAllowed(userDetails.userlevel, "shopeditoffers")) && renderOfferUpdates()}
        <Box mb={2}>
          <ImageAlbum images={getImageOrLogoSrc(offer.images, offer.logo)} mainOnly={true} />
        </Box>
        <Box>
          {<CustomSectionCreator isSubtle={true} title="All Offers" /> }
          {shopoffers && shopoffers.offers && shopoffers.offers.map((offer, index) => (
              <AdminOfferListItem offer={offer} />
          ))}
        </Box>
      </Container>
  );

  const renderCategoryEdit = () => {
    switch (shopModeState) {

      case "SHOP_DETAIL":
        return (
            <>
              <CustomSectionCreator isSubtle={true} title="Shop Information" />
              <ShopHeaderBack  {...props} onCancel={() => setShopModeState("PREVIEW")} />
              {offer && <AdminSellerShopDetail {...props} shopId={offer._id}/>}
            </>
        );
    }
  }


  return (
      <Container>
        {shopModeState === "PREVIEW" ? (
            <>
              <CustomSectionCreator isSubtle={true} title="Shop Offer" />
              <ShopHeaderBack  {...props} onCancel={cancelEdit} />
              {renderSearchModule()}
            </>
        ) : (
            renderCategoryEdit(shopModeState)
        )}
      </Container>
  );

};

AdminOfferSettingEditor.propTypes = {
  setState: PropTypes.func.isRequired,
  offer: PropTypes.object.isRequired,
  updateOfferSettingClicked: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default AdminOfferSettingEditor;
